<!--
 * @Author: your name
 * @Date: 2020-07-31 12:28:08
 * @LastEditTime: 2020-08-03 16:51:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-people-select/form-people-select.vue
-->
<template>
  <div class="form-people-select form-item" @click="handleClick">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="widget.readOnly">
    <x-tag-group
      v-if="renderSence === 'edit'"
      :tags="userArray"
      :countWidth="82"
      calcKey="username"
      :tagMarginWidth="3"
    >
        <template v-slot:tag="{ tag }">
          <x-user-tag
          :avatarUrl="tag.headPortrait"
          :personName="tag.username">
          </x-user-tag>
        </template>
    </x-tag-group>
    <template v-else-if="renderSence === 'read'">
      <template v-for="(item, index) in userArray">
        <x-user-tag
          :key="index"
          :avatarUrl="item.headPortrait"
          :personName="item.username">
          </x-user-tag>
      </template>
    </template>
    <span v-if="userArray.length === 0 && renderSence === 'edit' && !widget.readOnly" class="cube-input-field cube-input-field--placeholder">{{ widget.placeholder }}</span>
      <!-- <div v-if="renderSence === 'edit'" class="form-people-select-wrapper">

        <x-person-avatar
          v-for="user in userArray"
          :key="user.id"
          :personName="user.username"
        ></x-person-avatar>
      </div>
      <div v-if="renderSence === 'read'" class="form-people-select-wrapper">
        <x-person-avatar
          v-for="user in userArray"
          :key="user.id"
          :personName="user.username"
        ></x-person-avatar>
      </div> -->
    </x-proxy-form-item>
    <div v-if="renderSence === 'edit' && !widget.readOnly" class="form-item-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }">
      <x-svg-icon v-if="!userArray || userArray.length === 0" name="x-lib-arrow-right"></x-svg-icon>
      <x-svg-icon v-else name="x-lib-clear" @click.native="handleClear"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  name: 'FormPeopleSelect',
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  data() {
    return {
      compPayloadKey: this.$route.query.key
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    }),
    userArray() {
      return this.formValue ? (Array.isArray(this.formValue) ? this.formValue : [this.formValue]) : []
    },
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    }
  },
  methods: {
    handleClick() {
      // this.$formEventEmit('open-people-select')
      if (!this.widget.readOnly) {
        console.log(this.$route.query.inTable ? this.formDetailData : this.formData)
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: this.formValue,
          formData: this.$route.query.inTable ? this.formDetailData : this.formData
        })
      }
    },
    handleClear(e) {
      e.preventDefault()
      e.stopPropagation()
      this.formValue = []
    }
  }
}
</script>

<style lang="scss">
.form-people-select {
  position: relative;
  .form-item-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    justify-content: center;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    font-size: 0;
    &.full-height {
      height: 100%;
    }
    .x-svg-icon {
      color: #B2B2B2;
    }
  }
  .form-people-select-wrapper {
    width: 95%;
    display: flex;
    align-items: center;
    flex-flow: wrap;
    .x-person-avatar {
      margin-right: 4px;
      margin-top: 4px;
    }
  }
  .user-tag {
    display: inline-block;
    height: 1.72rem;
    line-height: 1.72rem;
    border-radius: 0.86rem;
    background-color: #F7F7F7;
    display: flex;
    align-items: center;
    white-space: nowrap;
    > span {
      padding-left: .285rem;
      padding-right: .86rem;
      font-size: 1rem;
      color: #101010;
    }
  }
}
</style>
